import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { DotLegalBreadCrumbModel, useDotLegalSnackbar, ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../localization/useTranslation";
import { useUrlProvider } from "../useUrlProvider";
import { UserViewModel } from "./User.types";
import { useDotLegalQueryClient, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useUserHook() {
    const urlProvider = useUrlProvider();
    const queryClient = useDotLegalQueryClient();
    const snackbar = useDotLegalSnackbar();
    const { id } = useParams<{ id: string }>();
    const { translateString, translateCountry } = useTranslation();

    const [showEditUserDialog, setShowEditUserDialog] = useState(false);
    const [showChangeActiveStatusDialog, setShowChangeActiveStatusDialog] = useState(false);
    const [showResendInvitationDialog, setShowResendInvitationDialog] = useState(false);
    const [showDeleteUserDialog, setShowDeleteUserDialog] = useState(false);
    let { isLoading, data: user } = useDotLegalQueryWithKey<UserViewModel>("user" + id, `/user/${id}`);

    const navigate = useNavigate();

    const handleEditUserSuccess = () => {
        queryClient.refetchQueries("user" + id);
        queryClient.refetchQueries("userGroupEntities" + id);
        setShowEditUserDialog(false);
    };

    const handeDeleteUserSuccess = (name: string) => {
        setShowDeleteUserDialog(false);
        navigate(urlProvider.getUsersUrl());
        snackbar.show(createElement(Trans, { i18nKey: "userDeleteSuccess", values: { name: name } }));
    };

    const handleChangeStatus = () => {
        queryClient.refetchQueries("user" + id);
    };

    const getBreadCrumbs = () => {
        let breadCrumbs: Array<DotLegalBreadCrumbModel> = [];

        breadCrumbs.push({ name: translateString("users"), link: urlProvider.getUsersUrl() });
        breadCrumbs.push({ name: user?.firstName ? user?.firstName + " " + user?.lastName : "" });

        return breadCrumbs;
    };

    return {
        isLoading,
        user,
        getBreadCrumbs,
        showEditUserDialog,
        setShowEditUserDialog,
        handleEditUserSuccess,
        showDeleteUserDialog,
        setShowDeleteUserDialog,
        handeDeleteUserSuccess,
        handleChangeStatus,
        setShowChangeActiveStatusDialog,
        showChangeActiveStatusDialog,
        showResendInvitationDialog,
        setShowResendInvitationDialog,
        userId: id!,
    };
}
